import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSetFile } from '../../utils/request';

const FormData = require('form-data');

const patchProfileAvatar = createAsyncThunk('profile/pathMyProfileAvatar',
  async ({ image } = {}, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('image', image);

      const { data: user } = await authSetFile('/me/avatar', formData, {
        'Content-Type': 'multipart/formdata',
      });
      return user;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default patchProfileAvatar;
